import React, { useState } from 'react';
import axios from 'axios';
import { KeyRound } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('admin_token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    if (newPassword !== confirmPassword) {
      setStatus('error:Passwords do not match');
      return;
    }
    if (newPassword.length < 6) {
      setStatus('error:Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/api/admin/change-password`, {
        current_password: currentPassword,
        new_password: newPassword,
      }, { headers: { Authorization: `Bearer ${token}` } });
      setStatus('success:Password changed successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setStatus(`error:${err.response?.data?.detail || 'Failed to change password'}`);
    } finally {
      setLoading(false);
    }
  };

  const isError = status.startsWith('error:');
  const message = status.replace(/^(error:|success:)/, '');

  return (
    <div className="p-8 max-w-lg" data-testid="change-password-page">
      <h1 className="text-3xl font-bold text-white mb-8">Change Password</h1>

      <Card className="bg-gray-900 border-gray-800">
        <CardHeader>
          <CardTitle className="text-white flex items-center space-x-2">
            <KeyRound size={20} className="text-orange-500" />
            <span>Update your password</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {message && (
              <div className={`px-4 py-2 rounded text-sm ${isError ? 'bg-red-900/30 border border-red-700 text-red-300' : 'bg-green-900/30 border border-green-700 text-green-300'}`} data-testid="password-status">
                {message}
              </div>
            )}
            <div className="space-y-2">
              <Label className="text-gray-300">Current Password</Label>
              <Input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="bg-gray-800 border-gray-700 text-white"
                data-testid="current-password-input"
                required
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">New Password</Label>
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="bg-gray-800 border-gray-700 text-white"
                data-testid="new-password-input"
                required
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Confirm New Password</Label>
              <Input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="bg-gray-800 border-gray-700 text-white"
                data-testid="confirm-password-input"
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-orange-600 hover:bg-orange-700"
              disabled={loading}
              data-testid="change-password-submit"
            >
              {loading ? 'Updating...' : 'Change Password'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminChangePassword;
